var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-tabs"
  }, [_c('router-link', {
    staticClass: "s-tab",
    class: {
      'active-tab': _vm.$route.name === 'WebPartnerMarketingIndex'
    },
    attrs: {
      "to": {
        name: 'WebPartnerMarketingIndex'
      }
    }
  }, [_vm._v(" 合作品牌點數交換 ")]), _c('router-link', {
    staticClass: "s-tab",
    class: {
      'active-tab': _vm.$route.name === 'WebPartnerMarketingLogs'
    },
    attrs: {
      "to": {
        name: 'WebPartnerMarketingLogs'
      }
    }
  }, [_vm._v(" 兌換紀錄查詢 ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }